import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithTokenHandling } from '../baseQuery';
import { EMAIL_TAG_TYPE } from './constants';

export const emailsApi = createApi({
  reducerPath: 'emails',
  baseQuery: baseQueryWithTokenHandling,
  tagTypes: [EMAIL_TAG_TYPE],
  endpoints: (builder) => ({
    uploadEmailList: builder.mutation<void, FormData>({
      query: (data) => ({
        url: '/v1/admin/emails/upload/',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useUploadEmailListMutation } = emailsApi;
